import { setWorkerURL, setupSearchWorkers } from "@circleofa/acim-engine"
import { acim } from "@utils/acim"
import { writable } from "svelte/store"
import searchWorkerURL from "@circleofa/acim-engine/dist/workers/search.worker.js?url"

setWorkerURL(searchWorkerURL)

/**
 * The search feature uses a SharedArrayBuffer which on older browsers does not work
 * so when we setup search workers, we don't want the application to crash
 * This acts an exposed check that pages can check to make sure that
 * they actually can run a search before doing so, and maybe put a little notice if
 * they can't
 */
export const accessibleSearch = writable(false)
export const searchReady = writable(false)

export function initSearchWorkers() {
    setupSearchWorkers(acim).then(() => {
        accessibleSearch.set(true)
        searchReady.set(true)
    })
}
